<template>
  <div class="row max-height-vertical box-overflow">
    <div class="row scroll-outer scroll-padding-bottom" ref="scrollHookOne">

      <!-- bump-up-24-lg -->
      <div class="span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs ">
        <p class="large" v-html="title"></p>
        <!-- bump-up-24-lg -->
        <p class="utility bump-up-24 bump-down-12-mobile">
          <strong>Click</strong> through each arrow to learn more before proceeding to the <strong>'Next'</strong> button.
        </p>
      </div>

      <!-- container for selector container and indicator card -->
      <div class="row span-16-lg span-16-md span-16-sm span-16-xs  ">

        <!-- selectors -->
        <!-- overflow-hidden -->
        <div class="span-9-lg offset-1-lg span-8-md max-height-selector  overflow-hidden">
          <progress-selector v-for="(card, index) in content.cards" v-bind:key="index" v-bind:index="index" v-bind:activeindex="offset_index"
            v-on:clicked="selectorCallback(card, index)" v-bind:ref="index + 1">
            {{card.title}}
          </progress-selector>
        </div>

        <!-- card -->
        <!-- center-flex-self -->
        <div class="span-4-lg offset-1-lg span-6-md offset-1-md span-16-sm span-16-xs bg-white border-blue-hover selector-indicator-card content-translate "
          container-card="selector-card" ref="selectorCard" :style="ratio_styles" v-on:click="toggleIndicator" v-bind:class="[indicatorClass, indicatorVisibleClass, contentActiveClass, hasContentClass]">

          <!-- mobile back arrow -->
          <div class="mobile-only arrow-back-container" v-on:click="toggleIndicator">
            <arrow type="prev"></arrow>
          </div>

          <div class="overflow-hidden center-flex cover-class crosshair-rollover-trigger" :class="hasContentClass">
            <div class="scroll-outer maintain-outer" ref="scrollHookTwo">
              <div v-if="card" class="card-inner">
                <component v-bind:is="card.icon" class="big-svg svg-fill-blue"></component>
                <p class="subheader color-blue">{{card.title}}</p>
                <p v-html="markedCard.paragraph"></p>
              </div>
            </div>
          </div>

          <crosshair-background></crosshair-background>

        </div>

      </div>
      <!--  -->

    </div>
  </div>
</template>

<script>
  import progress_selector from '../../components/molecules/progress_selector'
  import rollover_card from '../../components/molecules/rollover_card'
  import header_block from '../../components/organisms/header_block'
  import crosshair_background from '../../components/atoms/crosshair_background'
  import arrow from '../../components/atoms/arrow'
  import svg from '../../components/svg'
  import spacer from '../../components/atoms/spacer'

  import vanilla_smooth_scroll from '../../utils/vanilla_smooth_scroll'
  import {
    ratio_height,
    ratio_styles
  } from '../../utils/ratio_height'
  import {
    is_active
  } from '../../utils/is_active'
  import marked from 'marked'

  import PerfectScrollbar from 'perfect-scrollbar';

  import 'nodelist-foreach-polyfill'; // ie11


  // TODO: cleartimeouts and set scrolltos

  export default {
    props: ['title', 'content', 'active'],
    data() {
      return {
        card: null,
        offset_index: 0,
        multiplier: 84,
        ratio_styles,
        indicatorClass: 'indicator-not-in-view',
        indicatorVisibleClass: 'indicator-invisible',
        contentActiveClass: 'content-inactive',
        containerRef: null,
        timeouts: [],
        psOne: null,
        psTwo: null
      }
    },
    methods: {
      createMarked(str) {
        return marked(str)
      },
      set_card(content, index) {
        this.card = content
        this.offset_index += 1
        is_active(this, this.conditional())
      },
      selectorCallback(c, i) {
        // hide content
        this.indicatorVisibleClass = 'indicator-invisible'

        // clear previous actions if clicking through options fast
        for (let i = 0; i < this.timeouts.length; i++) {
          clearTimeout(this.timeouts[i])
        }

        // set card
        this.timeouts.push(
          setTimeout(() => {
            this.indicatorVisibleClass = ''
            this.set_card(c, i)
          }, 400),

          setTimeout(() => {
            const containerTwo = this.$refs.scrollHookTwo
            this.psTwo.update()
            vanilla_smooth_scroll(0, 150, null, containerTwo) // reset container to top
          }, 600) // update scrolls after content is set.
        )

        if (this.indicatorClass !== '') {
          this.toggleIndicator()
        }
      },
      conditional() {
        return this.active && this.offset_index < this.content.cards.length
      },
      toggleIndicator() { // todo: fix so it's not ternerary.
        if (this.indicatorClass === '') {
          this.indicatorClass = 'indicator-not-in-view'
        } else {
          this.indicatorClass = ''
        }
      },
      ratioInit() {
        ratio_height(this, this.$refs.selectorCard, 4 / 3)
        window.addEventListener('resize', () => {
          setTimeout(() => {
            ratio_height(this, '[container-card="selector-card"]', 4 / 3)
          }, 500) // prevent large sizes when rezising window from mobile to tablet
          setTimeout(() => {
            ratio_height(this, '[container-card="selector-card"]', 4 / 3)
          }, 1000)
          setTimeout(() => {
            ratio_height(this, '[container-card="selector-card"]', 4 / 3)
          }, 1500)
        })
      },
      scrollBarInit() {
        if (window.innerWidth > 1200 && window.innerHeight > 600 && !this.psOne) {
          const containerOne = this.$refs.scrollHookOne
          const containerTwo = this.$refs.scrollHookTwo
          this.psOne = new PerfectScrollbar(containerOne);
          this.psTwo = new PerfectScrollbar(containerTwo);
        } else if (window.innerWidth <= 1200 && this.psOne || window.innerHeight <= 600 && this.psOne) {
          this.psOne.destroy()
          this.psTwo.destroy()
          this.psOne = null
          this.psTwo = null
        }
        window.addEventListener('resize', this.scrollBarInit)
      },
      activeCallback() {
        let int = 800
        if (this.active) {
          setTimeout(() => {
            this.ratioInit()
            this.scrollBarInit()
            this.contentActiveClass = ''
          }, int)
          setTimeout(() => {
            if (this.psOne) this.psOne.update()
          }, int + 1000)
        } else {
          setTimeout(() => {
            this.contentActiveClass = 'content-inactive'
          }, int)
        }
      }
    },
    computed: {
      transform_style() {
        let offset = (this.offset_index * this.multiplier) - this.multiplier
        return {
          'transform': 'translateY(-' + offset + 'px)'
        }
      },
      markedCard() {
        if (this.card) {
          return {
            title: marked(this.card.title),
            paragraph: marked(this.card.paragraph)
          }
        }
      },
      hasContentClass() {
        if (this.card) {
          return 'hovered'
        }
      }
    },
    components: {
      'progress-selector': progress_selector,
      'rollover-card': rollover_card,
      'header-block': header_block,
      'crosshair-background': crosshair_background,
      'arrow': arrow,
      spacer,
      ...svg
    },
    watch: {
      active() {
        this.activeCallback()
        is_active(this, this.conditional())
      },
    },
  }

</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .selector-indicator-card {
    position: relative;
    border: 1px solid transparent;
    transition: all $transition-1, transform 1s ease; // margin-top: 42px;
    // max-height: calc(100% - 72px - 12px);
    .crosshair-rollover-trigger {
      transition: opacity $transition-1;
    }
    &.indicator-invisible {
      .crosshair-rollover-trigger {
        opacity: 0;
      }
    }
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      // height: 100% !important; // causing bugs in safari
      max-height: 100%;
    }
    @media screen and (max-width: $sm-max) {
      position: fixed;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh !important;
      background: white;

      &.indicator-not-in-view {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  }

  .max-height-selector {
    position: relative;
    min-height: calc(72px * 3); // max-height: calc(100vh - 96px - 98px - 48px); // todo: set this with js
    max-height: 100%;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      height: auto;
      max-height: 100% !important;
    }
  }

  .bump-up-60-lg {
    margin-top: -60px;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      margin-top: auto;
    }
  }

  .bump-up-24-lg {
    margin-top: -24px;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      margin-top: auto;
    }
  }

  .card-inner {
    position: relative;
    margin: auto;
    text-align: center;
    padding: 24px;
  }

  .arrow-back-container {
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 48px;
    margin-top: 24px;
    margin-left: 24px;
  }

  .progress-selector-container {
    position: relative;
    width: 100%;
  }

  .block-important {
    display: block !important;
  } // .center-flex-self {
  //   display: flex;
  //   align-self: center;
  // }
  // .scroll-spacer {
  //   position: relative;
  //   width: 100%;
  //   background: blue;
  //   @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
  //     display: none;
  //   }
  // }

</style>



// WEBPACK FOOTER //
// selector_page.vue?2a84a91a